import moment from 'moment'
import numeral from 'numeral'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['selectedBot']),
    isZwizAdmin() {
      return this.$store.state.userid.includes('zwiz')
    },
    isSearching() {
      var result = false
      for (const key in this.search) {
        if (key == 'tags') {
          if (this.search[key].length) {
            result = true
          }
        } else if (this.search[key]) {
          result = true
        }
      }
      return result
    },
  },
  methods: {
    dateFormat(val, format = 'DD/MM/YYYY') {
      if(val) {

        return moment(val).format(format)
      } else return ''
    },
    noSpaceAndSpecial(event, noTrim) {
      var val

      if (event.target) {
        val = event.target.value
      } else {
        val = event
      }

      try {
        if (!noTrim) {
          val = val.trim()
        }
        return val
          .replace(/[!$^,?:|<>]/g, '')
          .replace(/(‘|’)/gim, '')
          .replace(/(“|”)/gim, '')
          .replace(/​/gim, '')
          .replace(/ /gim, '')
      } catch (error) {
        return ''
      }
    },
    numberOnly(event, type) {
      var val = event.target.value.trim()
      var result

      if (typeof val === 'string') {
        result = val.replace(/\D/g, '')
      }
      if (type == 'hour') {
        result = parseFloat(result)
        if (result >= 24) {
          result = 23
        }
      }
      else if (type == 'minute') {
        result = parseFloat(result)
        if (result >= 60) {
          result = 59
        }
        result = result
      }


      return result
    },
    decimalOnly(event) {
      var val = event.target.value.trim()
      return numeral(val).value()
    },
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    isSupportLanguage: function (message, ispremium) {
      if (ispremium) return true
      else {
        return (
          message.search(
            /[^ก-๛a-zA-Z0-9\~\$\&\+\,\:\;\=\?\@\#\|\'\"\<\>\.\^\*\(\)\%\!\-\/\[\]\\\_\{\}\s]/gim
          ) === -1
        )
      }
    },
    isURL: function (str) {
      var pattern = new RegExp(
        /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
      ) // fragment locator
      return pattern.test(str)
    },
    isImageURL: function (str) {
      var pattern = new RegExp(/(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/g) // fragment locator
      return pattern.test(str)
    },
    isJsonParseable: function (str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    isNumber: function (str) {
      try {
        parseFloat(str)
      } catch (e) {
        return false
      }
      return true
    },
    exportCsv: function (csvContent, name) {
      var csvData = new Blob(['\uFEFF' + csvContent], { type: 'text/csv; charset=utf-18' }) // new way
      var csvUrl = URL.createObjectURL(csvData)

      var link = document.createElement('a')
      link.setAttribute(
        'style',
        'overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;'
      )
      link.setAttribute('href', csvUrl)
      link.setAttribute('download', moment().format('YYYY_MM_DD') + '_' + name + '.csv')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
    },
    exportText: function (csvContent, name) {
      var csvData = new Blob(['\uFEFF' + csvContent], { type: 'text/plain; charset=utf-18' }) // new way
      var csvUrl = URL.createObjectURL(csvData)

      var link = document.createElement('a')
      link.setAttribute(
        'style',
        'overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;'
      )
      link.setAttribute('href', csvUrl)
      link.setAttribute('download', name + '.txt')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
    },
    setLang: function (lang) {
      this.$store.dispatch('setLang', lang)
    },
    checkEmptyReplyMessage(messages) {
      return messages
        .map(function (m) {
          if (
            (m[0].replyinbox === true &&
              m[0].responseinbox[0].text !== '' &&
              m[0].responseinbox[0].text !== null) ||
            (m[0].replycomment === true &&
              m[0].responsecomment[0].text !== '' &&
              m[0].responsecomment[0].text !== null) ||
            m[0].hidecomment === true
          ) {
            if (m[0].replyinbox === true && m[0].responseinbox[0].type === 'generic') {
              m[0].responseinbox[0].data = m[0].responseinbox[0].data.filter(v => {
                return v.image_url || v.title || v.subtitle
              })
            }
            return m
          } else {
            return null
          }
        })
        .filter(el => {
          return el != null
        })
    },
    checkEmptyMessage(messages) {
      var result = messages
        .map(message => {
          return message
            .map(msg => {
              if (msg.type === 'text') {
                if (msg.text !== '' && msg.text != null) {
                  return msg
                }
              } else if (msg.type === 'button') {
                if ((msg.text !== '' && msg.text != null) || msg.buttons.length > 0) {
                  return msg
                }
              } else if (msg.type === 'image') {
                if (msg.image_url) {
                  return msg
                } else {
                  return null
                }
              } else if (msg.type === 'generic') {
                var generics = msg.data.filter((generic, gindex) => {
                  return (
                    generic.image_url != null ||
                    generic.title !== '' ||
                    generic.subtitle !== '' ||
                    (typeof generic.productid != 'undefined' && generic.productid != null) ||
                    generic.buttons.length > 0
                  )
                })

                if (generics.length > 0) {
                  return {
                    type: 'generic',
                    data: generics,
                    ratio: msg.ratio == 'horizontal' ? 'horizontal' : 'square'
                  }
                } else {
                  return null
                }
              } else if (msg.type === 'flex') {
                if (msg.contents !== '' && msg.contents != null) {
                  return msg
                } else {
                  return null
                }
              } else {
                return msg
              }
            })
            .filter(el => {
              return el != null
            })
        })
        .filter(message => {
          return message.length > 0
        })

      if (result.length === 0) {
        result = [[]]
      }

      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mainMixin.js